import React, { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom";
import { listCancellation } from "../../../Context/api";
import axios from "axios";
import { commonMessage, statusCodes } from "../../../Constants/generalConfig";
import Spinner from '../../Spinner/spinner';
import { ToastContainer, toast } from "react-toastify";

const List = () => {
  const [listData, setListData] = useState([]);
  const [spinner, setSpinner] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    list()
  }, [])
  const list = () => {
    setSpinner(true)
    axios.post(listCancellation(), {},).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        setListData(resp.data.data);
        setSpinner(false)
      }
      else {
        setListData([])
        setSpinner(false)
      }
    })
      .catch(() => {
        toast.error(commonMessage.networkError)
        setSpinner(false)
      })

  };
  return (
    <section>
      <ToastContainer />
      {spinner ? <Spinner /> : null}
      <div className="m-t-3 cus-padd cusheight">
        <header>
          <h2 className="page-tittle">Policy List</h2>
          <hr />
        </header>

        <p>Total Policy : {listData?.length}</p>
        <div className='d-flex justify-content-end align-item-center'>
          <div>
            <button className='btn btn-dark' onClick={() => navigate(`add-policy`)}>Add Policy</button>
          </div>
        </div>
        <table className="table  shadow mt-3">
          <thead className="table-dark">
            <tr>
              <th scope="col">#</th>
              <th scope="col">Refund Type</th>
              <th scope="col">Validity</th>
              <th scope="col">Days</th>
              <th scope="col">Cancellation Charge(%)</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody className='text-center'>

            {
              !listData?.length ? <div className='position-absolute top-10 end-50 mt-5'><h3>No record found</h3></div>
                :
                listData?.map((item, index) => {
                  return (
                    <>
                      <tr key={index}>
                        <th style={{ padding: "0.4rem .5rem" }} scope="row">
                          {index + 1}
                        </th>
                        <td style={{ padding: "0.4rem .5rem" }}>{item?.refundType}</td>
                        <td style={{ padding: "0.4rem .5rem" }}>{item?.validity}</td>
                        <td style={{ padding: "0.4rem .5rem" }}>{item?.days}</td>
                        <td style={{ padding: "0.4rem .5rem" }}>{item?.cancellationCharge}</td>
                        <td style={{ padding: "0.4rem .5rem" }}>
                          <svg onClick={() => navigate(`edit-policy/${item._id}`)} style={{ cursor: "pointer", fill: 'black' }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-pencil-fill" viewBox="0 0 16 16">
                            <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                          </svg>
                        </td>

                      </tr>
                    </>
                  );
                })}
          </tbody>
        </table>
      </div>
    </section>
  )
}

export default List